module.exports = __webpack_public_path__ + "assets/media/bellsound.7e7c9718.mp3";